"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-simple-auth/lib/utils/identity.js
// module id = 672
// module chunks = 0